/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';

const borderWidth = '1px';

const border = `${borderWidth} solid ${colors.N40}`;

export const PathHit = styled.div({
  borderTop: border,
  display: 'flex',
  padding: `1em ${gridSize()}px`,
  '&:first-child': {
    borderTop: 'none',
  },
});
